import React from "react"

function IconAt({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="at"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-at"
      {...props}
    >
      <path
        d="M5.509 5.514c3.413-3.435 8.91-3.493 12.418-.192l.222.215.24.249c1.561 1.683 2.4 3.848 2.378 6.08-.04 4.2-4.102 5.71-6.839 3.176l-.15-.145-.198-.026-.226.12a3.49 3.49 0 0 1-1.95.337 3.371 3.371 0 0 1-2.043-.999c-1.374-1.373-1.374-3.57-.003-4.917 1.38-1.359 3.577-1.366 4.917-.002a3.47 3.47 0 0 1 .648 4.033l-.103.187.025.199.126.12c1.702 1.535 4.3.69 4.3-2.08a7.355 7.355 0 0 0-2.19-5.266c-2.942-2.989-7.788-2.93-10.682.136-2.839 3.009-2.608 7.97.493 10.714a7.434 7.434 0 0 0 6.527 1.686c.354-.078.717.14.835.498a.758.758 0 0 1-.576.974 8.908 8.908 0 0 1-8.17-2.432c-3.489-3.491-3.489-9.152 0-12.665zm7.79 4.872c-.777-.778-2.067-.762-2.852.047-.795.796-.81 2.06-.02 2.85.788.788 2.055.774 2.85-.023.788-.814.796-2.1.023-2.874z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconAt
